import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbDatepickerModule, NgbModalModule, NgbNavModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { AuthGuard } from '../core/security/auth.guard';
import { PermissionConst } from '../core/security/generated/Permission';
import { AuditHistoryComponent } from './audit-history/audit-history.component';
import { BounceAlertComponent } from './bounce-alert/bounce-alert.component';
import { FaNumIconComponent } from "./fa-num-icon/fa-num-icon.component";
import { FormElementsModule } from './form-elements/form-elements.module';
import { NavigationModule } from './navigation/navigation.module';
import { NewHelpModuleButtonComponent } from './new-help-module-button/new-help-module-button.component';
import { OrdinalDatePipe } from './pipes/ordinal-date.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { StepperComponent } from './stepper/stepper.component';
import { TableModule } from './table/table.module';

const routes = [
	{
		path: 'audit-history/:id'
		, component: AuditHistoryComponent
		, canActivate: [AuthGuard]
		, canLoad: [AuthGuard]
		, data: { security: PermissionConst.coreFeatures }
	}
];

/**
 * SharedModule exists to make commonly used components, directives,
 * and pipes available for use in the templates of components throughout
 * the application.
 */
@NgModule({
	declarations: [
		StepperComponent
		, AuditHistoryComponent
		, BounceAlertComponent
		, SafePipe
		, OrdinalDatePipe
		, NewHelpModuleButtonComponent
		, FaNumIconComponent
	]
    , imports: [
		CommonModule
		, FormElementsModule
		, NgSelectModule
		, MatTableModule
		, MatButtonToggleModule
		, MatSlideToggleModule
		, MatSidenavModule
		, MatListModule
		, CdkTableModule
		, CdkStepperModule
		, NgbTooltipModule
		, NgbDatepickerModule
		, NgbModalModule
		, NgbTypeaheadModule
		, NgbNavModule
		, FormsModule
		, NavigationModule
		, TableModule
		, ReactiveFormsModule
		, FontAwesomeModule
		, RouterModule.forChild(routes)
	]
    , exports: [
		CommonModule
		, FormElementsModule
		, NgSelectModule
		, MatTableModule
		, MatButtonToggleModule
		, MatSlideToggleModule
		, MatSidenavModule
		, MatListModule
		, CdkTableModule
		, NgbTooltipModule
		, NgbDatepickerModule
		, NgbModalModule
		, NgbTypeaheadModule
		, NgbNavModule
		, FormsModule
		, NavigationModule
		, TableModule
		, ReactiveFormsModule
		, CdkStepperModule
		, StepperComponent
		, FontAwesomeModule
		, AuditHistoryComponent
		, RouterModule
		, BounceAlertComponent
		, SafePipe
		, OrdinalDatePipe
		, NewHelpModuleButtonComponent
		, FaNumIconComponent
	]
})
export class SharedModule { }